import React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const SelectAllButton = ({
  areAllSelected,
  value,
  allRelatedIds,
  onChange,
  t,
  className,
  disabled = false,
}) => {
  const handleClick = (e) => {
    e.stopPropagation();

    if (areAllSelected) {
      onChange(value.filter((id) => !allRelatedIds.includes(id)));
    } else {
      const newValues = Array.from(new Set([...value, ...allRelatedIds]));

      onChange(newValues);
    }
  };

  return (
    <Button
      disabled={disabled}
      variant="ghost"
      size="xs"
      className={cn(
        areAllSelected
          ? "bg-orange-100 text-orange-700 hover:bg-orange-200"
          : "bg-blue-100 text-blue-700 hover:bg-blue-200",
        className,
      )}
      onClick={handleClick}
    >
      {areAllSelected ? t("Unselect All") : t("Select All")}
    </Button>
  );
};

export default SelectAllButton;
